responsibility_translations = {
	corporate_responsibility_archives: {
		en: "Corporate Responsibility Archives",
		cn: "企业责任档案",
		es: "Archivos de responsabilidad corporativa",
		pt: "Arquivos de responsabilidade corporativa",
		ru: "Архивы корпоративной ответственности"
	},
	cr_page_intro: {
		en: "Together we fly. Gulfstream is committed to strengthening our communities, reducing our environmental impact and maintaining a strong and diverse workforce. Employees serve as stewards of our local communities around the world through many initiatives and partnerships, while developing both personally and professionally through programs, practices and policies.",
		cn: "我们一起齐飞共进。湾流致力于支持所在社区，减少自身对环境的影响，并维持强大和多样化的员工队伍。员工通过众多举措和伙伴关系服务于我们在世界各地的当地社区，同时通过各种项目、实践和政策促进个人和专业发展。",
		es: "Juntos, volamos. Gulfstream tiene el firme compromiso de fortalecer nuestras comunidades, reducir nuestro impacto ambiental y contar con una fuerza de trabajo fuerte y diversa. Los empleados actúan como guardianes de nuestras comunidades locales en todo el mundo a través de numerosas iniciativas y asociaciones, mientras se desarrollan personal y profesionalmente a través de programas, prácticas y políticas.",
		pt: "Voamos juntos. A Gulfstream tem o compromisso de fortalecer nossas comunidades, reduzir nosso impacto ambiental e manter uma equipe de trabalho forte e diversificada. Os funcionários atuam como guardiões de nossas comunidades em todo o mundo por meio de muitas iniciativas e parcerias, e se desenvolvem pessoal e profissionalmente por meio de programas, práticas e políticas.",
		ru: "Партнерство в полете. Компания Gulfstream оказывает поддержку регионам, в которых осуществляет свою деятельность, снижает негативное воздействие на окружающую среду и поддерживает высокую квалификацию и разнообразие персонала. Наши сотрудники во всех регионах мира активно участвуют в общественной работе в местных сообществах, что выражается в многочисленных инициативах и партнерских отношениях. При этом, благодаря различным программам, практикам и политикам, они развиваются как лично, так и профессионально."
	},
	published: {
		en: "Published",
		cn: "发表于",
		es: "Publicada",
		pt: "Publicado",
		ru: "Опубликовано"
	},
	download_fact_sheet: {
		en: "Download Fact Sheet",
		cn: "下载资料简报",
		es: "Descargar hoja de datos",
		pt: "Baixar Ficha de dados",
		ru: "Скачать информационный бюллетень"
	},
	view_archives: {
		en: "View Archives",
		cn: "查阅档案",
		es: "Ver archivos",
		pt: "Ver arquivos",
		ru: "Просмотреть архивы"
	},
	return: {
		en: "Return",
		cn: "返回",
		es: "Regresar",
		pt: "Voltar",
		ru: "Вернуться"
	},
	gulfstream_in_the_community: {
		en: "Gulfstream In The Community",
		cn: "Gulfstream对社区的贡献",
		es: "Gulfstream en la comunidad",
		pt: "Gulfstream na comunidade",
		ru: "Gulfstream в сообществе"
	}
};
